import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "coaches-list" }
const _hoisted_2 = { class: "coaches-list-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_5 = {
  key: 1,
  class: "error-state"
}
const _hoisted_6 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 3,
  class: "coaches-grid"
}
const _hoisted_8 = { class: "coach-photo" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "coach-info" }
const _hoisted_11 = { class: "coach-name" }
const _hoisted_12 = { class: "coach-headline" }
const _hoisted_13 = { class: "coach-stats" }
const _hoisted_14 = { class: "stat-item" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = { class: "stat-item" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = {
  key: 0,
  class: "coach-specialities"
}
const _hoisted_21 = { class: "speciality-tags" }
const _hoisted_22 = { class: "coach-actions" }

import { ref, onMounted } from 'vue';
  import TopbarOrganism from '@/components/organisms/topbar-organism/TopbarOrganism.vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';
  import { useRouter } from 'vue-router';
  import coachService, { CoachListItem } from '@/services/coach/coach.service';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CoachesListView',
  setup(__props) {

  const router = useRouter();
  const coaches = ref<CoachListItem[]>([]);
  const loading = ref(false);
  const error = ref('');

  const navigateToCreate = () => {
    router.push({ path: '/coach-create' });
  };

  const navigateToEdit = (coachId: string) => {
    router.push({ path: `/coach-edit/${coachId}` });
  };

  const fetchCoaches = async () => {
    loading.value = true;
    error.value = '';

    try {
      const response = await coachService.getAll();
      coaches.value = response.data || [];
    } catch (err) {
      console.error('Error fetching coaches:', err);
      error.value = 'Failed to fetch coaches. Please try again.';
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    fetchCoaches();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopbarOrganism, {
      linkText: "Coaches",
      showIcon: false,
      primaryButtonText: "Add Coach",
      onPrimaryClick: navigateToCreate
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Coaches Management", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("p", null, " Manage your coaches here. Click \"Add Coach\" to create a new coach profile. ", -1)),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
              _createElementVNode("p", null, "Loading coaches...", -1)
            ])))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(error.value), 1),
                _createElementVNode("button", {
                  onClick: fetchCoaches,
                  class: "retry-btn"
                }, "Retry")
              ]))
            : (coaches.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                  _createElementVNode("p", null, "No coaches found. Create your first coach to get started!", -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coaches.value, (coach) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: coach.coach_id,
                      class: "coach-card"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: coach.coach_photo,
                          alt: `${coach.coach_name} ${coach.coach_lastname}`
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h3", _hoisted_11, _toDisplayString(coach.coach_name) + " " + _toDisplayString(coach.coach_lastname), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(coach.coach_headline), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "stat-label" }, "Experience:", -1)),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(coach.years_of_experience) + " years", 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "stat-label" }, "Rate:", -1)),
                            _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(coach.price_per_hour) + "/hour", 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "stat-label" }, "Rating:", -1)),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(coach.average_rating || 'N/A') + " (" + _toDisplayString(coach.total_reviews) + " reviews)", 1)
                          ])
                        ]),
                        (coach.specialities && coach.specialities.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coach.specialities, (speciality) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: speciality.speciality_id,
                                    class: "speciality-tag"
                                  }, _toDisplayString(speciality.speciality_name), 1))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(ButtonAtom, {
                            class: "btn btn-secondary btn-small",
                            onClick: ($event: any) => (navigateToEdit(coach.coach_id)),
                            disabled: false
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Edit Coach ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
      ])
    ])
  ]))
}
}

})